import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const acBusData = [
  { srNo: 1, capacity: '13 TT', rate: '₹8100', extraKm: '₹27', local: '₹6000', extraHour: '₹500', mumbai: '₹10000', mahabaleshwar: '₹10000', shirdi: 'On Call' },
  { srNo: 2, capacity: '15 Exe.TT', rate: '₹9000', extraKm: '₹30', local: '₹6500', extraHour: '₹500', mumbai: '₹11000', mahabaleshwar: '₹11000', shirdi: 'On Call' },
  { srNo: 3, capacity: '17 TT', rate: '₹9100', extraKm: '₹31', local: '₹7000', extraHour: '₹500', mumbai: '₹11000', mahabaleshwar: '₹12000', shirdi: 'On Call' },
  { srNo: 4, capacity: '20 TT', rate: '₹9600', extraKm: '₹32', local: '₹7000', extraHour: '₹500', mumbai: '₹12000', mahabaleshwar: '₹12000', shirdi: 'On Call' },
  { srNo: 5, capacity: '24 SEAT AC', rate: '₹10500', extraKm: '₹35', local: '₹7200', extraHour: '₹500', mumbai: '₹18000', mahabaleshwar: '₹14000', shirdi: 'On Call' },
  { srNo: 6, capacity: '30 SEAT AC', rate: '₹13500', extraKm: '₹45', local: '₹9500', extraHour: '₹500', mumbai: '₹23000', mahabaleshwar: '₹15000', shirdi: 'On Call' },
  { srNo: 7, capacity: '35 BENZ', rate: '₹15000', extraKm: '₹50', local: '₹9500', extraHour: '₹500', mumbai: '₹23000', mahabaleshwar: '₹16000', shirdi: 'On Call' },
  { srNo: 8, capacity: '35 BENZ AIR SUSP', rate: '₹17000', extraKm: '₹55', local: '₹10500', extraHour: '₹500', mumbai: '₹24000', mahabaleshwar: '₹17000', shirdi: 'On Call' },
  { srNo: 9, capacity: '45 EICHER/TATA', rate: '₹21000', extraKm: '₹65', local: '₹14000', extraHour: '₹500', mumbai: '₹25000', mahabaleshwar: '₹19500', shirdi: 'On Call' },
  { srNo: 10, capacity: '45 LAYLAND', rate: '₹21000', extraKm: '₹65', local: '₹14000', extraHour: '₹500', mumbai: '₹25000', mahabaleshwar: '₹19500', shirdi: 'On Call' },
  { srNo: 11, capacity: '45 BENZ', rate: '₹21000', extraKm: '₹70', local: '₹16000', extraHour: '₹500', mumbai: '₹27000', mahabaleshwar: '₹21000', shirdi: 'On Call' }
];

const AcBusFareCard = () => {
  const phoneNumber = '917353109555'; // without '+'
  const sendWhatsApp = (capacity) => {
    const message = `Hi, I want to book a ${capacity} bus.`;
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <section style={{ backgroundColor: '#F9FEFF', padding: '40px 20px' }}>
      <div className="container">
        <h4 className="text-white bg-darkk p-3 rounded-top">AC BUS FARE CARD</h4>
        <div className="table-responsive">
          <table className="table table-bordered text-center align-middle">
            <thead className="table-dark " >
              <tr>
                <th className='table-darkk'>SR.NO</th>
                <th className='table-darkk'>SEATING CAPACITY</th>
                <th className='table-darkk'>PER KM RATE (300 KM PACKAGE)</th>
                <th className='table-darkk'>EXTRA KM</th>
                <th className='table-darkk'>8/80 PUNE LOCAL</th>
                <th className='table-darkk'>EXTRA HOUR</th>
                <th className='table-darkk'>MUMBAI UPTO 350 KM</th>
                <th className='table-darkk'>MAHABALESHWAR UPTO 300 KMS</th>
                <th className='table-darkk'>SHIRDI (450 KM)</th>
                <th className='table-darkk'>BOOK NOW</th>
              </tr>
            </thead>
            <tbody>
              {acBusData.map((bus, index) => (
                <tr key={index} className={index % 2 !== 0 ? 'table-light' : ''}>
                  <td>{bus.srNo}</td>
                  <td>{bus.capacity}</td>
                  <td>{bus.rate}</td>
                  <td>{bus.extraKm}</td>
                  <td>{bus.local}</td>
                  <td>{bus.extraHour}</td>
                  <td>{bus.mumbai}</td>
                  <td>{bus.mahabaleshwar}</td>
                  <td>{bus.shirdi}</td>
                  <td>
                    <button
                      className="btn btn-dark btn-sm"
                      onClick={() => sendWhatsApp(bus.capacity)}
                    >
                      Book Now
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default AcBusFareCard;
